export enum TicketStatusTypes {
    New = 0,
    InProgress = 1,
    AwaitingMemberResponse = 2,
    AwaitingAdminResponse = 3,
    TOS = 4,
    UpgradePaymentDeclined = 5,
    UpgradeOK = 6,
    Closed = 99,
}

export enum TicketUrgencyTypes {
    Low = 0,
    Normal = 1,
    High = 2,
    SuperHigh = 3
}

export class CustomTicketItem {

    TicketID: number;
    TicketNumber: string;
    OriginalAdminID: number;
    OriginalAdminName: string;
    AdminID: number;
    AdminName: string;
    OriginalMemberID: string;
    OriginalMemberName: string;
    MemberID: number;
    MemberName: string;
    IsInternal: boolean;
    DueDate: Date;
    DateTimeCreated: Date;
    CreatedByAdmin: boolean;
    FromEmail: string;
    Status: TicketStatusTypes;
    Urgency: TicketUrgencyTypes;
    Subject: string;
    Body: string;
    IsHTMLBody: boolean;
    Replies: CustomTicketItemArray;
    ParentID: number;

    public static FixDates(item: CustomTicketItem) {
        if (item.DueDate != null && item.DueDate != undefined)
            item.DueDate = new Date(item.DueDate);

        item.DateTimeCreated = new Date(item.DateTimeCreated);

        if (item.Replies != undefined)
            CustomTicketItemArray.FixDates(item.Replies);
    }
}

export class CustomTicketItemArray extends Array<CustomTicketItem> {

    constructor(...items: CustomTicketItem[]) {
        super(...items);
        Object.setPrototypeOf(this, CustomTicketItemArray.prototype);
    }

    public static FixDates(items: CustomTicketItemArray) {
        items.forEach(x => CustomTicketItem.FixDates(x));
    }

}
